import React from "react";
import styled from "styled-components";
import RecordingSrc from "../../../../../images/icons/recording-icon.svg";

const RecordingBarWrapper = styled.section`
    font-weight: 700;
    color: white;
    font-size: 21px;
    line-height: 25px;
    padding: 17px;
    z-index: 200;
    left: 90px;
    position: absolute;
    
    display: none;
    
    ${(props) => (props.open ? {
    'display': 'block',
} : '')}
`;

const RecordingIcon = styled.img`
    width: 33px;
    height: 33px;
    float: left;
    position: relative;
    top: 3px;
    margin-right: 10px;
`;

const Seconds = styled.span`

`;

const PauseButton = styled.button`
        color: white;
    background: #818181;
    border-radius: 5px;
    font-size: 18.9px;
    line-height: 23px;
    padding: 9px 15px;
    border: 0;
    box-sizing: border-box;
    font-weight: 700;
    margin-left: 18px;
    cursor: pointer;
    
    ${(props) => (props.hidden ? {
    'display': 'hidden',
} : '')}
`;

export default class RecordingBar extends React.Component {
    render() {
        return (
            <div>
                <RecordingBarWrapper open={this.props.open}>
                    <RecordingIcon src={RecordingSrc}></RecordingIcon>
                    {this.props.pauseStateText+" | "} <Seconds>{this.props.time}</Seconds><PauseButton hidden={!this.props.show_recording_button} onClick={this.props.toggleRecording}>{this.props.pauseButtonText}</PauseButton>
                </RecordingBarWrapper>
            </div>
        );
    }
}